















































import { Mixins, Component, Prop } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

// Components
import ClientInvoiceConsolidationForm from "@/components/app/global/client/clientInvoiceConsolidationForm.vue";

// Types
import { IClient } from "@/models/clients";
import { IBrand } from "@/models/brands";
import Context from "@/mixins/context";

@Component({
  components: {
    "client-invoice-consolidation-form": ClientInvoiceConsolidationForm
  }
})
export default class ClientInvoiceConsolidationComp extends Mixins(Context) {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    clientInvoiceConsolidationForm: ClientInvoiceConsolidationForm;
  };

  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise", "div"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: "" })
  public brandName!: IBrand["name"];

  @Prop({ default: false })
  public isSticky!: boolean;

  @Prop({ default: null })
  public label!: string | null;

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    this.$refs.clientInvoiceConsolidationForm.validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs.clientInvoiceConsolidationForm.revertToInitialState();
  }
}
